module.exports = __webpack_public_path__ + "static/media/kylas.13af3696.webp";